<template>
    <div>
        <LoadingScreen v-if="isLoadingScreen"></LoadingScreen>
        <div class="loto__numbers" v-else>
            <div class="loto__list__logo">
                <img src="~ThemePath/images/logo.png" />
            </div>
            <div class="loto__list__head">
                <div class="loto__list__head__name">
                    {{ getTranslatedText(`guinne ${dataSource.title }`) }}
                </div>
                <div class="loto__list__head__title">{{ dataSource.title }} {{ dataSource.gameNumber }}</div>
            </div>
            <div v-if="freebetActive" class="loto__freebet-banner">
                {{ getTranslatedText('extra7 boost') }} - {{ getTranslatedText('freebet mode') }}
                <span v-if="$store.state.freebetContext"> ({{ freebetRemaining }} {{ getTranslatedText('free spin') }})</span>
            </div>
            <div v-if="isFreebetSequence" class="loto__freebet-steps">
                <div class="loto__freebet-steps__label">
                    {{ getTranslatedText('draw') }} {{ freebetStepIndex + 1 }}/{{ freebetDraws.length }}
                    <span v-if="currentDrawLabel"> — {{ currentDrawLabel }}</span>
                </div>
                <div class="loto__freebet-steps__dots">
                    <span
                        v-for="(d, idx) in freebetDraws"
                        :key="idx"
                        class="loto__freebet-steps__dot"
                        :class="{ 'is-filled': isDrawFilled(idx), 'is-current': idx === freebetStepIndex }"
                    ></span>
                </div>
            </div>
            <div v-if="this.$store.state.isAllowDoubleChance && !isBoostActive && !isBonusActive && !freebetActive && betOptions && betOptions.length > 0" class="loto__numbers__bet_options">
                <div v-for="(value, index) in betOptions" class="loto__numbers__bet_options-item">
                    <input :id="'r_' + index" type="radio" name="betOptionRadio" v-model="selectedBetOption" :value="value"/>
                    <label :for="'r_' + index">{{ getTranslatedText(getBetOptionName(value)) }}</label>
                </div>
            </div>
            <div class="loto__numbers__quick-pick">
                <SelectPickNumber v-if="allowedPicks" :rangePickNumber="rangePickNumber" @select-pick="selectNumberPick" />
                <ButtonCommon v-else :isNoHover="false" value="Quick Pick"
                    className="screen-number__btn-quick-pick" nameFunction="on-quick-pick-number" />
            </div>
            <div class="loto__numbers__list">
                <div class="loto__numbers__item" :class="{ active: selection.includes(value.number) }"
                    v-for="(value, index) in listNumber" :key="index" @click="() => onSelectNumber(value.number)">
                    {{ value.number }}
                </div>
            </div>
            <div class="loto__numbers__value-number">
                <input autocomplete="off" @keyup="removeDotDash" v-model="valueSelection" class="loto__numbers__input" type="text" pattern="[0-9]" inputmode="numeric" @blur="onBlurValueSelection" ref="inputValueNumber" @keyup.enter="hideKeypad('inputValueNumber')" />
            </div>
            <div class="screen-number__footer">
                <div class="screen-number__container-price">
                    <div class="screen-number__info">
                        <span class="screen-number__text bold">{{ wagerSectionTitle }}</span>
                        <span class="screen-number__text">{{ wagerSectionAmount }}</span>
                    </div>
                    <div v-if="!freebetActive" class="screen-number__box-input">
                        <span class="screen-number__box-input--text wager">
                            <b>{{ getTranslatedText("wager ticket") }}</b>
                            <span v-if="!isBoostActive && !isBonusActive">
                                ({{ getTranslatedText("min") }}
                                {{ renderPrice(WAGER_MIN_ENV, 0) }} - {{ getTranslatedText("max") }}
                                {{ renderPrice(WAGER_MAX_ENV, 0) }})
                            </span>
                        </span>
                        <input v-model="priceNumber" class="screen-number__input price" step="1" min="0" max="100" pattern="[0-9]*" inputmode="numeric" @blur="onBlurPriceNumber" v-on:keypress="onlyNumber" ref="inputPrice" @keyup.enter="hideKeypad('inputPrice')" :disabled="isBoostActive || isBonusActive" />
                    </div>
                    <div v-if="!isBoostActive && !isBonusActive && !freebetActive" class="screen-number__box-button">
                        <ButtonCommon :value="`+${renderPrice('1000', 0)}`" :paramFunction="1000"
                            nameFunction="on-change-price-number" />
                        <ButtonCommon :value="`+${renderPrice('5000', 0)}`" :paramFunction="5000"
                            nameFunction="on-change-price-number" />
                        <ButtonCommon :value="`+${renderPrice('10000', 0)}`" :paramFunction="10000"
                            nameFunction="on-change-price-number" />
                    </div>
                </div>
                <div class="screen-number__info screen-number__info__custom">
                    <span class="screen-number__text bold">{{ getTranslatedText("total") }}</span>
                    <span class="screen-number__text bold">{{ renderPrice(totalNumber) }}</span>
                </div>
                <div class="screen-number__box-button screen-number__box-button__custom">
                    <ButtonCommon :isNoHover="true" :class-name="'screen-number__box-button__clear'" value="clear" nameFunction="on-show-dialog-clear" />
                    <div class="screen-number__add-cart-column">
                        <button
                            v-if="canShowBoostToggle && !freebetActive"
                            type="button"
                            class="screen-number__boost-bar"
                            :class="{ 'screen-number__boost-bar--active': isBoostEnabled }"
                            @click="toggleBoost"
                        >
                            {{ isBoostEnabled ? getTranslatedText('extra7 boost active') : getTranslatedText('extra7 boost') }}
                        </button>
                        <button
                            v-if="canShowBonusToggle"
                            type="button"
                            class="screen-number__boost-bar screen-number__bonus-bar"
                            :class="{ 'screen-number__boost-bar--active': isBonusEnabled }"
                            @click="toggleBonus"
                        >
                            {{ isBonusEnabled ? getTranslatedText('extra7 bonus active') : getTranslatedText('extra7 bonus') }}
                        </button>
                        <template v-if="isFreebetSequence">
                            <div class="screen-number__freebet-nav">
                                <ButtonCommon v-if="freebetStepIndex > 0" :isNoHover="true" :class-name="'screen-number__freebet-btn'" value="back" nameFunction="on-freebet-back" />
                                <ButtonCommon v-if="freebetStepIndex < freebetDraws.length - 1" :class-name="'screen-number__box-button__add-to-cart'" :isNoHover="true" type="error" value="next draw" nameFunction="on-freebet-next" />
                                <ButtonCommon v-else :class-name="'screen-number__box-button__add-to-cart'" :isNoHover="true" type="error" value="add all to cart" nameFunction="on-freebet-finalize" :isLoading="$store.state.isLoadingAddCart" />
                            </div>
                            <ButtonCommon :isNoHover="true" :class-name="'screen-number__freebet-btn'" value="quick pick remaining" nameFunction="on-freebet-qp-remaining" />
                        </template>
                        <ButtonCommon v-else :class-name="'screen-number__box-button__add-to-cart'" :isNoHover="true" type="error" value="add to cart" nameFunction="on-add-to-cart" :isLoading="$store.state.isLoadingAddCart" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoadingScreen from "@/components/common/loading/index.vue";
import languageMixins from "@/mixins/language/language-mixins";
import EventBus from "@/utils/EventBus";
import ButtonCommon from "@/components/common/button/index.vue";
import SelectPickNumber from "@/components/games/number-quick-pick.vue";
import { formatPrice, isStrEmpty, removeDotDash } from "@/utils/utils";
const WAGER_MIN_ENV = process.env.VUE_APP_WAGER_MIN || 2000;
const WAGER_MAX_ENV = process.env.VUE_APP_WAGER_MAX || 50000;
const WAGER_BOOST_ENV = process.env.VUE_APP_WAGER_BOOST || 3000;
// Extra 7 Ticket Bonus — optional +1,000 GNF add-on entry (configurable like Boost's wager).
const WAGER_BONUS_ENV = process.env.VUE_APP_WAGER_BONUS || 1000;

export default {
    mixins: [languageMixins],
    components: { ButtonCommon, LoadingScreen, SelectPickNumber },
    data() {
        return {
            dataSource: {},
            selection: [],
            listNumber: [],
            rangePickNumber: [],
            valueSelection: "",
            WAGER_MIN_ENV,
            WAGER_MAX_ENV,
            priceNumber: 0,
            selectedBetOption: '',
            betOptions: [],
            totalNumber: 0,
            defaultWager: 0,
            numberQp: 2,
            isLoadingScreen: true,
            allowedPicks: false,
            isBoostEnabled: false,
            isBonusEnabled: false,
            isExtra7Game: false,
            WAGER_BOOST_ENV,
            WAGER_BONUS_ENV,
            // FreeBet multi-draw: which draw is being picked, and the saved combo per draw.
            freebetStepIndex: 0,
            freebetSelections: [],
        };
    },
    computed: {
        freebetActive() {
            return !!this.$store.state.freebetContext
        },
        // Spins already committed to the 5/90 betslip (one bet per selected event).
        freebetSpinsInCart() {
            return (this.$store.state.transact || []).reduce(
                (sum, e) => sum + ((e.event_id && e.event_id.length) || 1),
                0
            )
        },
        // Live remaining free spins = coupon remaining minus what's already in cart.
        freebetRemaining() {
            const ctx = this.$store.state.freebetContext
            const total = ctx ? parseInt(ctx.remaining, 10) || 0 : 0
            return Math.max(total - this.freebetSpinsInCart, 0)
        },
        canShowBoostToggle() {
            const cashierSlugs = this.$store.state.userInfo?.details?.enabled_game_slugs || ''
            const boostAllowed = this.$store.state.isShowExtra7Boost
                || cashierSlugs.indexOf('extra7-boost') !== -1
                || this.freebetActive
            // Boost is a normal-market-only bet — never offer it when a double
            // chance market is selected (double chance only / normal + double chance).
            const isNormalMarket = this.selectedBetOption !== 'double_chance' && this.selectedBetOption !== 'both'
            return boostAllowed && this.isExtra7Game && this.selection.length === 4 && isNormalMarket
        },
        isBoostActive() {
            return this.canShowBoostToggle && this.isBoostEnabled
        },
        // Extra 7 Ticket Bonus toggle. Sibling of Boost, but gated on the FULL bonus
        // game slug (not a short fake slug). Independent of Boost — both may be active.
        canShowBonusToggle() {
            const cashierSlugs = this.$store.state.userInfo?.details?.enabled_game_slugs || ''
            const bonusAllowed = this.$store.state.isShowExtra7Bonus
                || cashierSlugs.indexOf('lotto-guinee-5-90-extra7-bonus') !== -1
            // Bonus is a normal-market-only bet — never offer it alongside a double
            // chance market. Not offered inside a Boost FreeBet sequence.
            const isNormalMarket = this.selectedBetOption !== 'double_chance' && this.selectedBetOption !== 'both'
            return bonusAllowed && !this.freebetActive && this.isExtra7Game && this.selection.length === 4 && isNormalMarket
        },
        isBonusActive() {
            return this.canShowBonusToggle && this.isBonusEnabled
        },
        // What each selected draw adds to the total on top of the unit price shown in
        // the wager box, so the on-screen total matches what the cart will hold:
        //   Bonus on           → the 1,000 bonus bet
        //   Boost AND Bonus on → plus a standard 2,000 bet, because the Bonus attaches
        //                        to a STANDARD Extra 7 ticket while Boost stays its own
        //                        bet — three bets per draw, not two.
        packAddOnPerDraw() {
            if (!this.isBonusActive) return 0
            let addOn = parseFloat(this.WAGER_BONUS_ENV)
            if (this.isBoostActive) addOn += parseFloat(WAGER_MIN_ENV)
            return addOn
        },
        // Wager-section header. Base is "Extra 7"; Boost appends "(Boost - 4 Numbers)",
        // Ticket Bonus appends "- BONUS" (both can apply when both toggles are active).
        wagerSectionTitle() {
            let title = `${this.getTranslatedText(`${this.dataSource.title}`)} ${this.dataSource.gameNumber}`
            if (this.isBoostActive) {
                title = `${title} (${this.getTranslatedText('boost 4 numbers')})`
            }
            if (this.isBonusActive) {
                title = `${title} - ${this.getTranslatedText('bonus').toUpperCase()}`
            }
            return title
        },
        // Wager-section amount. When Bonus is active, show the composition so the pack
        // stake is explicit — "2,000 + 1,000" (standard base + bonus add-on).
        wagerSectionAmount() {
            const parts = [this.renderPrice(this.dataSource.wager, 2)]
            if (this.isBonusActive) {
                // Boost owns the base line, so the standard ticket the Bonus attaches to
                // is billed on top of it.
                if (this.isBoostActive) parts.push(this.renderPrice(WAGER_MIN_ENV, 2))
                parts.push(this.renderPrice(this.WAGER_BONUS_ENV, 2))
            }
            return parts.join(' + ')
        },
        // The ordered draws picked on the event screen, paired with their info.
        freebetDraws() {
            const ids = (this.dataSource && this.dataSource.event_id) || []
            const info = (this.dataSource && this.dataSource.eventInfo) || []
            return ids.map((id, i) => ({
                event_id: id,
                name: info[i] ? info[i].name : '',
                date: info[i] ? info[i].date : '',
            }))
        },
        // FreeBet across >1 draws: step through one combo per draw. A single-draw
        // freebet keeps the normal one-shot add-to-cart flow untouched.
        isFreebetSequence() {
            return this.freebetActive && this.freebetDraws.length > 1
        },
        currentDrawLabel() {
            const draw = this.freebetDraws[this.freebetStepIndex]
            if (!draw) return ''
            return [draw.name, draw.date].filter((x) => x).join(' ')
        },
    },
    mounted() {
        this.fetchData();
    },
    created() {
        EventBus.$on('on-change-price-number', (param) => this.onChangePriceNumber(param))
        EventBus.$on('on-quick-pick-number', () => this.onClickQuickPick())
        EventBus.$on('on-clear-select-number', () => this.onClearSelectNumber())
        EventBus.$on('on-show-dialog-clear', () => this.onShowConfirmClear())
        EventBus.$on('on-add-to-cart', () => this.onAddToCart())
        EventBus.$on('on-freebet-next', () => this.freebetNext())
        EventBus.$on('on-freebet-back', () => this.freebetBack())
        EventBus.$on('on-freebet-finalize', () => this.freebetFinalize())
        EventBus.$on('on-freebet-qp-remaining', () => this.freebetQpRemaining())
    },
    destroyed() {
        EventBus.$off('on-change-price-number')
        EventBus.$off('on-quick-pick-number')
        EventBus.$off('on-clear-select-number')
        EventBus.$off('on-show-dialog-clear')
        EventBus.$off('on-add-to-cart')
        EventBus.$off('on-freebet-next')
        EventBus.$off('on-freebet-back')
        EventBus.$off('on-freebet-finalize')
        EventBus.$off('on-freebet-qp-remaining')
    },
    watch: {
        selection() {
            this.renderValueNumber()
            if (this.selection.length !== 4) {
                this.isBoostEnabled = false
                this.isBonusEnabled = false
            } else if (this.freebetActive && this.canShowBoostToggle) {
                // FreeBet redemption: Boost is mandatory — auto-enable it.
                this.isBoostEnabled = true
            }
        },
        isBonusEnabled(enabled) {
            // Pack stake must be exactly 3,000 GNF: lock the standard stake to the
            // fixed 2,000 GNF while Bonus is on. If Boost is also active it owns the
            // 3,000 base — leave its price untouched. Restore the default on un-toggle.
            if (!this.isBoostActive) {
                this.priceNumber = enabled ? this.renderPrice(WAGER_MIN_ENV, 0) : this.defaultWager
                this.dataSource.wager = enabled ? parseFloat(WAGER_MIN_ENV) : parseFloat(String(this.defaultWager).replace(/,/g, ''))
            }
            // Reflect the +1,000 add-on in the on-screen total.
            let price = this.priceNumber.replace(/,/g, '')
            let mul = this.selectedBetOption == 'both' ? 2 : 1
            this.totalNumber = mul * parseFloat(price) * this.dataSource.event_id.length
            this.totalNumber += this.packAddOnPerDraw * this.dataSource.event_id.length
        },
        isBoostEnabled(enabled) {
            if (enabled && this.canShowBoostToggle) {
                if (this.betOptions && this.betOptions.length > 0) {
                    this.selectedBetOption = this.betOptions[0]
                }
                this.priceNumber = this.renderPrice(WAGER_BOOST_ENV, 0)
                this.dataSource.wager = WAGER_BOOST_ENV
            } else if (!enabled) {
                this.priceNumber = this.defaultWager
            }
        },
        priceNumber() {
            let price = this.priceNumber.replace(/,/g, "");
            this.totalNumber = parseFloat(price) * this.dataSource.event_id.length;
            this.totalNumber += this.packAddOnPerDraw * this.dataSource.event_id.length;
            this.dataSource.wager = parseFloat(price);
        },
        selectedBetOption() {
            // console.log('changed bet optiino', this.selectedBetOption)
            let price = this.priceNumber.replace(/,/g, '')
            let mul = this.selectedBetOption == 'both' ? 2 : 1
            this.totalNumber = mul * parseFloat(price) * this.dataSource.event_id.length
            this.totalNumber += this.packAddOnPerDraw * this.dataSource.event_id.length
            this.dataSource.wager = parseFloat(price)
        },
        selectedBetOption() {
            // console.log('changed bet optiino', this.selectedBetOption)
            let price = this.priceNumber.replace(/,/g, '')
            let mul = this.selectedBetOption == 'both' ? 2 : 1
            this.totalNumber = mul * parseFloat(price) * this.dataSource.event_id.length
            this.totalNumber += this.packAddOnPerDraw * this.dataSource.event_id.length
        },
        dataSource() {
            this.$nextTick(() => {
                this.scrollByOnePixel();
            });
        },
    },
    methods: {
        getBetOptionName(slug) {
            switch (slug) {
                case 'both': return 'normal and double chance'
                case 'double_chance': return 'double chance only'
                default: return 'normal only'
            }
        },
        scrollByOnePixel() {
            window.scrollBy(0, 1);
        },

        fetchData() {
            let dataNumber = localStorage.getItem('loto-number')
            if (isStrEmpty(dataNumber)) {
                this.$router.push('/loto')
            }
            dataNumber = JSON.parse(dataNumber);

            if (dataNumber.betOptions && dataNumber.betOptions.length > 0) {
                this.betOptions = dataNumber.betOptions;
                this.selectedBetOption = this.betOptions[0]
            }

            let allowedPicks = dataNumber.allowedPicks;
            this.dataSource = dataNumber;
            // Boost is ONLY for Extra 7. Extra 6 shares grouping "extra" but must
            // never show Boost, so require the game number to be 7 (or an explicit
            // extra7 slug) rather than matching the whole "extra" grouping.
            this.isExtra7Game = ((dataNumber.title || '').toLowerCase() === 'extra' && String(dataNumber.gameNumber) === '7')
                || (dataNumber.game || '').includes('extra7')
            // FreeBet Extra 7 Boost: lock the pick to exactly 4 numbers regardless
            // of how this screen was reached, so only "4" is offered and Boost applies.
            if (this.freebetActive && this.isExtra7Game) {
                allowedPicks = { min: 4, max: 4 }
                this.dataSource.allowedPicks = allowedPicks
                this.dataSource.numberQp = 4
                this.numberQp = 4
            }
            this.allowedPicks = allowedPicks;
            //this.numberQp = dataNumber.numberQp;
            this.defaultWager = dataNumber.defaultWager;
            this.priceNumber = dataNumber.priceNumber;
            this.listNumber = Array.from(Array(90), (_, i) => {
                return { number: ++i };
            });
            this.rangePickNumber = allowedPicks ? Array.from({ length: allowedPicks.max - allowedPicks.min + 1 }, (_, index) => index + allowedPicks.min) : []
            this.isLoadingScreen = false;
        },

        onlyNumber(event) {
            if (event.key === "-" && event.target.selectionStart !== 0) {
                event.preventDefault();
                return;
            }
            if (event.keyCode < 48 || event.keyCode > 57) {
                event.preventDefault();
            }
        },

        onAddToCart() {
            this.$store.state.isLoadingAddCart = true

            // Never mix paid and freebet tickets in the same 5/90 betslip. If freebet
            // tickets are already in the cart but we're no longer in freebet mode
            // (e.g. context was reset), block adding a paid ticket.
            if (!this.freebetActive && (this.$store.state.transact || []).some((e) => e && e.free_bet)) {
                EventBus.$emit('show-notications', {
                    text: this.getTranslatedText('freebet clear cart first'),
                    type: 'warning',
                })
                this.$store.state.isLoadingAddCart = false
                return false
            }

            const allowedPicks = this.dataSource.allowedPicks
            const selectionNumber = this.selection.length;

            if (allowedPicks && (selectionNumber < allowedPicks.min || allowedPicks.max < selectionNumber)
                || (!allowedPicks && this.dataSource.numberQp > selectionNumber)
            ) {
                let text = allowedPicks ? `Please make sure that you select from ${allowedPicks.min} to ${allowedPicks.max} of balls!`
                    : `Please make sure that you select ${this.dataSource.numberQp} of balls!`
                const param = {
                    text: text,
                    type: "warning",
                };
                EventBus.$emit("show-notications", param);
                this.$store.state.isLoadingAddCart = false;

                return false;
            }

            // FreeBet: never let the cart exceed the coupon's remaining free spins
            // (one spin per selected event). Block here instead of failing at pay time.
            if (this.freebetActive) {
                const ctx = this.$store.state.freebetContext || {}
                const totalSpins = parseInt(ctx.remaining, 10) || 0
                const adding = (this.dataSource.event_id && this.dataSource.event_id.length) || 1
                if (this.freebetSpinsInCart + adding > totalSpins) {
                    EventBus.$emit('show-notications', {
                        text: this.getTranslatedText('freebet too many spins') + ' (' + totalSpins + ')',
                        type: 'warning',
                    })
                    this.$store.state.isLoadingAddCart = false
                    return false
                }
            }

            const param = this.dataSource
            let wager = this.priceNumber.replace(/,/g, '')
            param['selectedBetOption'] = this.selectedBetOption
            param['selection'] = this.selection
            param['date'] = this.selection
            param['wager'] = parseFloat(wager)
            param['totalCart'] = this.totalNumber
            param['id'] = new Date().getTime().toString(36).concat(performance.now().toString(), Math.random().toString()).replace(/\./g, '')
            param['gameType'] = 'loto-590'
            param['boost'] = this.isBoostActive
            // Ticket Bonus add-on. When active, the store expands this selection into
            // two entries (standard + a 1,000 GNF bonus entry, same numbers/draw).
            param['is_bonus_ticket'] = this.isBonusActive
            param['bonus_wager'] = parseFloat(this.WAGER_BONUS_ENV)
            // Standard Extra 7 stake. Only used when Boost is on too: the base line is
            // then the boosted bet, so the standard ticket the Bonus attaches to has to
            // be added as its own bet at this stake.
            param['base_wager'] = parseFloat(WAGER_MIN_ENV)
            // FreeBet ticket: force normal market (Boost has no double chance) and tag
            // it with the coupon code so it stays a freebet all the way to checkout —
            // it can never be confused with a paid bet, even if context is reset.
            if (this.freebetActive) {
                param['selectedBetOption'] = (this.betOptions && this.betOptions.length) ? this.betOptions[0] : 'normal'
                param['free_bet'] = true
                param['freebet_code'] = (this.$store.state.freebetContext || {}).code
                // Total spins the coupon grants — stamped on the ticket so the
                // all-at-once check survives a reset of the transient context.
                param['freebet_total'] = parseInt((this.$store.state.freebetContext || {}).remaining, 10) || 0
            }
            this.$store.dispatch('onAddToCart', param)
            this.onClearSelectNumber()
            localStorage.removeItem('loto645-event')
        },

        onClearSelectNumber() {
            this.isBoostEnabled = false
            this.isBonusEnabled = false
            this.priceNumber = this.defaultWager
            this.selection = []
        },

        onShowConfirmClear() {
            const param = {
                title: process.env.VUE_APP_I18N_LOCALE === "fr" ? "warning" : "confirm delete",
                description: "Are you sure you want to delete?",
                nameFunction: "on-clear-select-number",
            };
            EventBus.$emit("on-show-dialog", param);
        },

        onClickQuickPick() {
            const allowedPicks = this.dataSource.allowedPicks
            let numberSelect = allowedPicks ? this.numberQp : this.dataSource.numberQp

            let numbers = Array(90)
                .fill(0)
                .map((_, index) => index + 1);
            numbers.sort(() => Math.random() - 0.5);
            numbers = [...numbers.slice(0, numberSelect)];
            this.selection = [...numbers];
        },

        renderValueNumber() {
            const selection = [...this.selection];
            const numberSelect = selection.sort((a, b) => a - b);

            this.valueSelection = this.renderTextTickets(numberSelect);
        },

        onChangePriceNumber(value) {
            // Boost fixes the stake at 3,000; Ticket Bonus fixes the pack at 3,000
            // (standard locked to 2,000) — neither allows editing the wager.
            if (this.isBoostActive || this.isBonusActive) return
            let price = value || 0
            let priceNumber = this.priceNumber.replace(/,/g, '')
            let priceMore = parseFloat(priceNumber) + price
            if (priceMore > WAGER_MAX_ENV) priceMore = WAGER_MAX_ENV
            this.priceNumber = this.renderPrice(priceMore, 0)
            this.dataSource.wager = priceMore
        },

        renderTextTickets(arr) {
            let valueNumberSelectRender = "";
            arr.forEach((x, index) => {
                valueNumberSelectRender = `${valueNumberSelectRender}${index !== 0 ? "," : ""} ${x}`;
            });
            return valueNumberSelectRender;
        },

        onBlurPriceNumber() {
            if (this.isBoostActive || this.isBonusActive) return
            let priceNumber = this.priceNumber.replace(/,/g, '')
            let price = priceNumber !== '' ? priceNumber : 0
            let value = parseFloat(price)
            if (value < this.WAGER_MIN_ENV) value = this.WAGER_MIN_ENV
            if (value > this.WAGER_MAX_ENV) value = this.WAGER_MAX_ENV
            this.priceNumber = this.renderPrice(value, 0)
        },

        onBlurValueSelection() {
            let inputArray = this.valueSelection
                .split(",")
                .map((num) => Number(num.trim()))
                .filter((num, index, self) => num >= 1 && num <= 90 && index === self.indexOf(num));

            inputArray = inputArray.slice(0, this.dataSource.numberQp);
            this.valueSelection = inputArray.join(",");
            this.selection = [...inputArray];
        },

        removeDotDash (e) {
            this.valueSelection = removeDotDash(this.valueSelection)
        },

        onSelectNumber(number) {
            const allowedPicks = this.dataSource.allowedPicks
            const selection = this.selection;
            const index = selection.findIndex((x) => x === number);
            if (index !== -1) {
                selection.splice(index, 1);
            } else {
                if ((!allowedPicks && this.dataSource.numberQp > this.selection.length) ||
                    (allowedPicks && this.selection.length < allowedPicks.max)) {
                    selection.push(number);
                }
            }

            this.selection = [...selection];
        },

        renderPrice(price, decimal) {
            return formatPrice(price, decimal);
        },

        hideKeypad(ref) {
            this.$refs[ref].blur();
        },

        selectNumberPick(pick) {
            this.numberQp = pick;
            this.onClickQuickPick();
        },

        toggleBoost() {
            // FreeBet mode: Boost is mandatory and cannot be turned off.
            if (this.freebetActive) return
            this.isBoostEnabled = !this.isBoostEnabled
        },

        toggleBonus() {
            // Ticket Bonus is independent of Boost — both can be active at once.
            this.isBonusEnabled = !this.isBonusEnabled
        },

        // ── FreeBet multi-draw sequence ────────────────────────────────────
        // Whether a picked combo satisfies the allowed-picks rule (4 for boost).
        isSelectionValid(sel) {
            const ap = this.dataSource.allowedPicks
            const n = (sel || []).length
            if (ap) return !(n < ap.min || ap.max < n)
            return n >= this.dataSource.numberQp
        },
        // A fresh independent random combo of the required size (4 for boost).
        randomCombo() {
            const size = this.dataSource.numberQp || 4
            const numbers = Array(90).fill(0).map((_, i) => i + 1)
            numbers.sort(() => Math.random() - 0.5)
            return numbers.slice(0, size).sort((a, b) => a - b)
        },
        // A draw "filled" = it has a valid saved combo (drives the progress dots).
        isDrawFilled(idx) {
            if (idx === this.freebetStepIndex) return this.isSelectionValid(this.selection)
            return this.isSelectionValid(this.freebetSelections[idx])
        },
        // Stash the working selection for the current draw.
        saveCurrentStep() {
            this.$set(this.freebetSelections, this.freebetStepIndex, [...this.selection])
        },
        // Move to another draw, loading its previously-saved combo (preserve & edit).
        loadStep(idx) {
            this.freebetStepIndex = idx
            this.selection = [...(this.freebetSelections[idx] || [])]
        },
        freebetNext() {
            if (!this.isSelectionValid(this.selection)) {
                EventBus.$emit('show-notications', {
                    text: this.getTranslatedText('please make sure that you select [number] of balls!', { number: this.dataSource.numberQp }),
                    type: 'warning',
                })
                return
            }
            this.saveCurrentStep()
            this.loadStep(this.freebetStepIndex + 1)
        },
        freebetBack() {
            // Keep whatever is on screen (even partial) so it isn't lost on return.
            this.saveCurrentStep()
            this.loadStep(this.freebetStepIndex - 1)
        },
        // Fill every draw that doesn't yet have a valid combo with a random one,
        // then go straight to the cart.
        freebetQpRemaining() {
            this.saveCurrentStep()
            this.freebetDraws.forEach((draw, i) => {
                if (!this.isSelectionValid(this.freebetSelections[i])) {
                    this.$set(this.freebetSelections, i, this.randomCombo())
                }
            })
            this.freebetFinalize()
        },
        // Push one cart entry per draw (each event_id:[dN] + its own selection),
        // which is the multi-entry payload the game API already accepts.
        freebetFinalize() {
            this.saveCurrentStep()

            for (let i = 0; i < this.freebetDraws.length; i++) {
                if (!this.isSelectionValid(this.freebetSelections[i])) {
                    EventBus.$emit('show-notications', {
                        text: this.getTranslatedText('please make sure that you select [number] of balls!', { number: this.dataSource.numberQp }),
                        type: 'warning',
                    })
                    this.loadStep(i)
                    return
                }
            }

            // Never exceed the coupon's remaining spins (one spin per draw).
            const ctx = this.$store.state.freebetContext || {}
            const totalSpins = parseInt(ctx.remaining, 10) || 0
            if (this.freebetSpinsInCart + this.freebetDraws.length > totalSpins) {
                EventBus.$emit('show-notications', {
                    text: this.getTranslatedText('freebet too many spins') + ' (' + totalSpins + ')',
                    type: 'warning',
                })
                return
            }

            this.$store.state.isLoadingAddCart = true
            const boostWager = parseFloat(WAGER_BOOST_ENV)
            const betOption = (this.betOptions && this.betOptions.length) ? this.betOptions[0] : 'normal'
            this.freebetDraws.forEach((draw, i) => {
                const param = {
                    ...this.dataSource,
                    event_id: [draw.event_id],
                    eventInfo: [{ name: draw.name, date: draw.date }],
                    selection: this.freebetSelections[i],
                    date: this.freebetSelections[i],
                    selectedBetOption: betOption,
                    wager: boostWager,
                    totalCart: boostWager,
                    id: new Date().getTime().toString(36).concat(performance.now().toString(), Math.random().toString(), String(i)).replace(/\./g, ''),
                    gameType: 'loto-590',
                    boost: true,
                    free_bet: true,
                    freebet_code: ctx.code,
                    freebet_total: parseInt(ctx.remaining, 10) || 0,
                }
                this.$store.dispatch('onAddToCart', param)
            })
            this.$store.state.isLoadingAddCart = false

            // Reset the sequence and open the cart.
            this.freebetSelections = []
            this.freebetStepIndex = 0
            this.onClearSelectNumber()
            EventBus.$emit('open-betslip')
        },
    },
};
</script>
<style lang="scss">
@import '~ThemePath/scss/loto/_index.scss';

.loto__freebet-banner {
    margin: 8px 12px;
    padding: 8px 12px;
    border-radius: 8px;
    background-color: #fff4d6;
    color: #8a5a00;
    font-weight: 700;
    text-align: center;
    border: 1px solid #f0c46b;
}

.loto__freebet-steps {
    margin: 0 12px 8px;
    text-align: center;

    &__label {
        font-weight: 700;
        color: #8a5a00;
    }

    &__dots {
        display: flex;
        justify-content: center;
        gap: 8px;
        margin-top: 6px;
    }

    &__dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #e0c9a0;
        border: 1px solid #f0c46b;

        &.is-filled {
            background-color: #8a5a00;
        }

        &.is-current {
            box-shadow: 0 0 0 2px #8a5a00;
        }
    }
}

.screen-number__freebet-nav {
    display: flex;
    gap: 8px;

    > * {
        flex: 1;
    }
}
</style>
